import { render, staticRenderFns } from "./rightTag.vue?vue&type=template&id=36b0ce88&scoped=true"
import script from "./rightTag.vue?vue&type=script&lang=js"
export * from "./rightTag.vue?vue&type=script&lang=js"
import style0 from "./rightTag.vue?vue&type=style&index=0&id=36b0ce88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b0ce88",
  null
  
)

export default component.exports